module.exports = __webpack_public_path__ + "img/alert.1d3d7d7a.svg";